import React from "react";
import sub_text_icon from "../../Images/gre-aa.png";
import person from "../../Images/men-img.png";
import abtImg from "../../Images/about.png";
import trangle from "../../Images/org-tr.png";
import dots from "../../Images/ab-dot.png";
import "./AboutComponentDetails.css";


const AboutComponentDetails = () => {
  return (
    <div className="troo-da-about-section" id="troo-da-about-section"> 
      <div className="galaxy">
        <div className="mercury"></div>
      </div>
      <div className="vert-move ab-ss">
        <img src="images/ab-dot.png" alt="" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="about-text sub-about-pa">
              <div className="sub-title">
                <div className="text-sub">
                  <img className="up" src={sub_text_icon} alt="sub-text-icon" />
                  About us
                </div>
                <div className="title">
                  <h2>
                    <span>
                      We working for you to build your <br />
                    </span>
                    business fast
                  </h2>
                </div>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer too.
              </p>
              <ul>
                <li>
                  <strong>Our Mission</strong>
                  <span>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy.
                  </span>
                </li>
                <li>
                  <strong>Our Vission</strong>
                  <span>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy.
                  </span>
                </li>
              </ul>
              <div className="clinet-ss">
                <div className="cl-img">
                  <img src={person} alt="" />
                </div>
                <div className="cl-tx">
                  <strong>Navil Williams</strong>
                  <span>Founder and CEO</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="about-left-img">
              <img src={abtImg} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="vid-fig">
        <img src={trangle} alt="" />
      </div>
      <div className="vert-move ">
        <img src={dots} alt="" />
      </div>
    </div>
  );
};

export default AboutComponentDetails;
